import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "o-homeEstimateFlow"
}
const _hoisted_2 = { class: "o-homeEstimateFlow__inner" }
const _hoisted_3 = { class: "o-homeEstimateFlow__header" }
const _hoisted_4 = { class: "u-container u-container--fluid" }
const _hoisted_5 = { class: "u-row o-homeEstimateFlow__row" }
const _hoisted_6 = { class: "u-col-12 o-homeEstimateFlow__column" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  class: "o-homeEstimateFlow__logo__img",
  src: "/media/3inm2efn/logo-original.svg"
}, null, -1 /* HOISTED */)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = ["action"]
const _hoisted_10 = ["value"]
const _hoisted_11 = ["value"]
const _hoisted_12 = ["value"]
const _hoisted_13 = ["value"]
const _hoisted_14 = ["value"]
const _hoisted_15 = ["value"]
const _hoisted_16 = ["value"]
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "o-homeEstimateFlow__step" }
const _hoisted_19 = { class: "o-homeEstimateFlow__step__headline" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "o-homeEstimateFlow__step__image" }
const _hoisted_22 = ["id"]
const _hoisted_23 = { class: "o-homeEstimateFlow__step__corner-info" }
const _hoisted_24 = { class: "o-homeEstimateFlow__step o-homeEstimateFlow__step--6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StatusIndicator = _resolveComponent("StatusIndicator")!
  const _component_a_icon = _resolveComponent("a-icon")!
  const _component_Slider = _resolveComponent("Slider")!
  const _component_Actions = _resolveComponent("Actions")!
  const _component_ParameterExplainer = _resolveComponent("ParameterExplainer")!
  const _component_OrderEstimate = _resolveComponent("OrderEstimate")!
  const _component_SegmentationStep = _resolveComponent("SegmentationStep")!
  const _component_ContactBrokerModal = _resolveComponent("ContactBrokerModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_Transition, {
      name: "o-homeEstimateFlow",
      duration: 500,
      onAfterEnter: $options.onAfterEnterOverlayTransition
    }, {
      default: _withCtx(() => [
        ($options.isVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("a", {
                          href: "/",
                          class: "o-homeEstimateFlow__logo",
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($options.clickLogo && $options.clickLogo(...args)))
                        }, _hoisted_8),
                        _createVNode(_component_StatusIndicator, {
                          steps: $data.stepsAmount,
                          "active-step": $data.activeStep,
                          onChangeActiveStep: _cache[1] || (_cache[1] = ($event: any) => (
                                            $options.changeActiveStepFromStatus($event)
                                        ))
                        }, null, 8 /* PROPS */, ["steps", "active-step"])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("form", {
                  class: "o-homeEstimateFlow__steps",
                  action: _ctx.$props.dataConfiguration.resultPageUrl,
                  method: "get"
                }, [
                  _createElementVNode("input", {
                    id: "property",
                    type: "hidden",
                    name: "id",
                    value: _ctx.addressId
                  }, null, 8 /* PROPS */, _hoisted_10),
                  _createElementVNode("input", {
                    id: "udvendigstand",
                    type: "hidden",
                    name: "udvendigstand",
                    value: $data.ratings.exterior
                  }, null, 8 /* PROPS */, _hoisted_11),
                  _createElementVNode("input", {
                    id: "indvendigstand",
                    type: "hidden",
                    name: "indvendigstand",
                    value: $data.ratings.interior
                  }, null, 8 /* PROPS */, _hoisted_12),
                  _createElementVNode("input", {
                    id: "beliggenhed",
                    type: "hidden",
                    name: "beliggenhed",
                    value: $data.ratings.location
                  }, null, 8 /* PROPS */, _hoisted_13),
                  _createElementVNode("input", {
                    id: "energiniveau",
                    type: "hidden",
                    name: "energiniveau",
                    value: $data.ratings.energy
                  }, null, 8 /* PROPS */, _hoisted_14),
                  _createElementVNode("input", {
                    id: "herlighedsvaerdi",
                    type: "hidden",
                    name: "herlighedsvaerdi",
                    value: $data.ratings.amenity
                  }, null, 8 /* PROPS */, _hoisted_15),
                  _createElementVNode("input", {
                    id: "segment",
                    type: "hidden",
                    name: "segment",
                    value: encodeURI($data.segment)
                  }, null, 8 /* PROPS */, _hoisted_16),
                  _createElementVNode("input", {
                    id: "hash",
                    type: "hidden",
                    name: "hash",
                    value: $data.segmentHash
                  }, null, 8 /* PROPS */, _hoisted_17),
                  _createCommentVNode(" STEP 01 to 05 "),
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (n) => {
                    return _createVNode(_Transition, {
                      key: 'step' + n,
                      name: `o-homeEstimateFlow__step--${$data.currentDirection}`,
                      mode: "out-in",
                      duration: 500,
                      persisted: ""
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("div", _hoisted_18, [
                          _createElementVNode("h2", _hoisted_19, [
                            _createTextVNode(_toDisplayString(_ctx.$props[$data.ratingSteps[n - 1]].headline) + " ", 1 /* TEXT */),
                            _createElementVNode("button", {
                              class: "o-homeEstimateFlow__step__info",
                              type: "button",
                              onClick: ($event: any) => (
                                            $options.showEstimateTeaserInfo(
                                                _ctx.$props[$data.ratingSteps[n - 1]]
                                                    .headline,
                                            )
                                        )
                            }, [
                              _createVNode(_component_a_icon, { name: "info" })
                            ], 8 /* PROPS */, _hoisted_20)
                          ]),
                          _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("div", {
                              id: `lottie${n}`,
                              class: "o-homeEstimateFlow__step__lottieWrapper"
                            }, null, 8 /* PROPS */, _hoisted_22)
                          ]),
                          _createVNode(_component_Slider, {
                            "slider-instance": `slider-${n}`,
                            "slider-labels": _ctx.$props.dataConfiguration,
                            value: $options.loadSliderValues(n - 1),
                            onSetSliderValue: _cache[2] || (_cache[2] = ($event: any) => (
                                        $options.setHiddenSliderField($event)
                                    ))
                          }, null, 8 /* PROPS */, ["slider-instance", "slider-labels", "value"]),
                          _createVNode(_component_Actions, {
                            "active-step": $data.activeStep,
                            "prev-button-text": 
                                        n > 1
                                            ? _ctx.$props[$data.ratingSteps[n - 1]]
                                                  .backCtaText
                                            : ''
                                    ,
                            "prev-button-alt-text": 
                                        n > 1
                                            ? _ctx.$props[$data.ratingSteps[n - 1]]
                                                  .backCtaAltText
                                            : ''
                                    ,
                            "next-button-text": 
                                        _ctx.$props[$data.ratingSteps[n - 1]].ctaText
                                    ,
                            "next-button-alt-text": 
                                        _ctx.$props[$data.ratingSteps[n - 1]].ctaAltText
                                    ,
                            onFlowNavigation: _cache[3] || (_cache[3] = ($event: any) => ($options.flowNavigation($event)))
                          }, null, 8 /* PROPS */, ["active-step", "prev-button-text", "prev-button-alt-text", "next-button-text", "next-button-alt-text"]),
                          _createElementVNode("div", _hoisted_23, [
                            _createVNode(_component_ParameterExplainer, {
                              texts: {
                                            stepHeadline:
                                                _ctx.$props[$data.ratingSteps[n - 1]]
                                                    .headline,
                                            explainerText:
                                                _ctx.$props[$data.ratingSteps[n - 1]]
                                                    .brokerHelpText,
                                            infoOpenText:
                                                _ctx.$props[$data.ratingSteps[n - 1]]
                                                    .brokerLinkText,
                                            infoHeadline:
                                                _ctx.$props[$data.ratingSteps[n - 1]]
                                                    .infoHeadline,
                                            infoDescription:
                                                _ctx.$props[$data.ratingSteps[n - 1]]
                                                    .infoText,
                                            ariaLabel:
                                                _ctx.$props[$data.ratingSteps[n - 1]]
                                                    .infoHeadline,
                                        },
                              step: n,
                              "show-speech-bubble": $data.showBubble,
                              "broker-link-text-line-break": 
                                            _ctx.$props[$data.ratingSteps[n - 1]]
                                                .brokerLinkTextLineBreak
                                        
                            }, null, 8 /* PROPS */, ["texts", "step", "show-speech-bubble", "broker-link-text-line-break"]),
                            _createVNode(_component_OrderEstimate, {
                              texts: {
                                            brokerCardText:
                                                _ctx.$props[$data.ratingSteps[n - 1]]
                                                    .brokerCardText,
                                            infoHeadline:
                                                _ctx.$props[$data.ratingSteps[n - 1]]
                                                    .infoHeadline,
                                        },
                              image: $data.responsibleBrokerImage,
                              step: n + 1,
                              "active-step-name": 
                                            _ctx.$props[$data.ratingSteps[n - 1]].headline
                                        ,
                              "broker-id": $data.responsibleBrokerId
                            }, null, 8 /* PROPS */, ["texts", "image", "step", "active-step-name", "broker-id"])
                          ])
                        ], 512 /* NEED_PATCH */), [
                          [_vShow, $data.activeStep === n]
                        ])
                      ], undefined, true),
                      _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["name"])
                  }), 64 /* STABLE_FRAGMENT */)),
                  _createCommentVNode(" STEP 06 "),
                  _createVNode(_Transition, {
                    name: `o-homeEstimateFlow__step--${$data.currentDirection}`,
                    mode: "out-in",
                    duration: 500,
                    persisted: ""
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("div", _hoisted_24, [
                        _createVNode(_component_SegmentationStep, {
                          "segments-step": _ctx.$props.dataSegmentation,
                          onSelectSegment: _cache[4] || (_cache[4] = ($event: any) => ($options.setSelectedSegment($event)))
                        }, null, 8 /* PROPS */, ["segments-step"]),
                        _createVNode(_component_Actions, {
                          "active-step": $data.activeStep,
                          "next-button-text": 
                                        _ctx.$props.dataSegmentation.nextStepCtaText
                                    ,
                          "next-button-alt-text": 
                                        _ctx.$props.dataSegmentation
                                            .nextStepCtaAltText
                                    ,
                          "next-button-disabled": 
                                        $data.segment === '' ? true : false
                                    ,
                          onFlowNavigation: _cache[5] || (_cache[5] = ($event: any) => ($options.flowNavigation($event))),
                          onSubmitForm: $options.submitForm
                        }, null, 8 /* PROPS */, ["active-step", "next-button-text", "next-button-alt-text", "next-button-disabled", "onSubmitForm"])
                      ], 512 /* NEED_PATCH */), [
                        [_vShow, $data.activeStep === 6]
                      ])
                    ], undefined, true),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["name"])
                ], 8 /* PROPS */, _hoisted_9)
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ], undefined, true),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["onAfterEnter"]),
    _createVNode(_component_ContactBrokerModal, {
      user: $props.user,
      "curtain-data": $data.brokerData
    }, null, 8 /* PROPS */, ["user", "curtain-data"])
  ]))
}